import { createBrowserHistory } from "history";
import ReactGA from "react-ga";

ReactGA.initialize("UA-42096921-3");
const history = createBrowserHistory();
history.listen(location => {
  ReactGA.pageview(location.pathname);
});

export default history;
